var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10C9.95182 10 10.8823 9.71775 11.6737 9.18895C12.4651 8.66015 13.0819 7.90854 13.4462 7.02917C13.8104 6.1498 13.9057 5.18216 13.72 4.24863C13.5343 3.3151 13.076 2.45759 12.403 1.78455C11.7299 1.11151 10.8724 0.653164 9.93887 0.467473C9.00534 0.281782 8.0377 0.377085 7.15834 0.741332C6.27897 1.10558 5.52736 1.72241 4.99855 2.51382C4.46975 3.30523 4.1875 4.23568 4.1875 5.1875C4.1875 6.46386 4.69453 7.68793 5.59705 8.59045C6.49957 9.49297 7.72365 10 9 10ZM9 11.375C6.01711 11.375 0.0625 13.2175 0.0625 16.875V19.625H17.9375V16.875C17.9375 13.2175 11.9829 11.375 9 11.375Z",
    fill: "#3A6AB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.59fcd44c219394dc64e0471e8923dd08.svg";
export { ForwardRef as ReactComponent };